import { IChartProps } from "./Charts.types";
import { ChartWrapper } from "./ChartWrapper";

export const Charts = ({ chartData }: IChartProps): JSX.Element => {
    if (!chartData) return <></>;

    return (
        <div>
            <h3>{chartData.title}</h3>
            <ChartWrapper chartData={chartData} />
            <p>{chartData.summary}</p>
        </div>
    );
};